import { genName } from '@/components/Subregions/utils';

export const PRIMARY = 'Primary';
const ADDITIONAL = 'Additional';

// Primary ranks the final-mile carrier; the middle-mile and warehouse slots of that row are not.
const isPrimaryFor = (mapping, carrierId) => mapping.is_primary && mapping.carrier_id === carrierId;

export const coverageSummary = ({ ownZips, resources, delivery_profiles: deliveryProfiles }) => {
    const zipCount = ownZips.aggregate.count;

    const subregionsTouched = deliveryProfiles.reduce((count, profile) => {
        const touchedInProfile = profile.subregions.reduce(
            (profileCount, subregion) => (subregion.claimedZips.aggregate.count > 0 ? profileCount + 1 : profileCount),
            0
        );

        return count + touchedInProfile;
    }, 0);

    return {
        zipCount,
        subregionsTouched,
        resourceCount: resources.length,
        isSubmitted: zipCount > 0,
    };
};

export const regionRows = (deliveryProfiles, carrierId) => {
    const rows = deliveryProfiles.reduce((regionList, profile) => {
        profile.subregions.forEach((subregion, idx) => {
            const claimed = subregion.claimedZips.aggregate.count;
            const isMapped = subregion.carriers.length > 0;

            if (!isMapped && claimed === 0) return;

            const isPrimary = subregion.carriers.some((mapping) => isPrimaryFor(mapping, carrierId));
            const mappedRole = isPrimary ? PRIMARY : ADDITIONAL;

            regionList.push({
                subregion_id: subregion.subregion_id,
                name: genName(subregion, idx),
                profileName: profile.name,
                claimed,
                total: subregion.zips_aggregate.aggregate.count,
                role: isMapped ? mappedRole : null,
            });
        });

        return regionList;
    }, []);

    return rows.sort((left, right) => right.claimed - left.claimed || left.name.localeCompare(right.name));
};

export const profilePlacements = (deliveryProfiles, carrierId) =>
    deliveryProfiles.reduce((placements, profile) => {
        const roles = profile.subregions.reduce((rolesInProfile, subregion) => {
            subregion.carriers.forEach((mapping) => {
                const mappedRole = isPrimaryFor(mapping, carrierId) ? PRIMARY : ADDITIONAL;
                rolesInProfile.add(mappedRole);
            });

            return rolesInProfile;
        }, new Set());

        if (roles.size === 0) return placements;

        // A shipper holds one assignment per order type, so it can sit on the same profile twice.
        const shippersById = profile.auto_assignments.reduce((byId, assignment) => {
            byId.set(assignment.shipper_id, {
                shipper_id: assignment.shipper_id,
                business_name: assignment.shipper.business_name,
            });

            return byId;
        }, new Map());

        placements.push({
            delivery_profile_id: profile.delivery_profile_id,
            name: profile.name,
            roles: [PRIMARY, ADDITIONAL].filter((role) => roles.has(role)),
            shippers: [...shippersById.values()],
        });

        return placements;
    }, []);
